import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

interface Resource {
  id: string;
  title: string;
  description: string;
  type: 'template' | 'guide' | 'checklist' | 'blueprint';
  icon: string;
  downloadUrl: string;
  downloads: number;
}

const ResourcesSection = () => {
  const resources: Resource[] = [
    {
      id: '1',
      title: 'Automation ROI Calculator',
      description:
        'Calculate potential time and cost savings from automation implementation',
      type: 'template',
      icon: 'Calculator',
      downloadUrl: '#',
      downloads: 2847
    },
    {
      id: '2',
      title: 'Workflow Design Blueprint',
      description: 'Step-by-step guide to designing efficient automation workflows',
      type: 'blueprint',
      icon: 'GitBranch',
      downloadUrl: '#',
      downloads: 1923
    },
    {
      id: '3',
      title: 'API Integration Checklist',
      description: 'Complete checklist for successful API integration projects',
      type: 'checklist',
      icon: 'CheckSquare',
      downloadUrl: '#',
      downloads: 1654
    },
    {
      id: '4',
      title: 'Automation Strategy Guide',
      description: 'Comprehensive guide to building your automation strategy',
      type: 'guide',
      icon: 'BookOpen',
      downloadUrl: '#',
      downloads: 3201
    }
  ];

  const typeColors: Record<string, string> = {
    template: '#10B981',
    guide: '#2563EB',
    checklist: '#F59E0B',
    blueprint: '#8B5CF6'
  };

  return (
    <div className="bg-gradient-to-br from-surface to-background border border-border rounded-xl p-6 sm:p-8">
      {/* Header */}
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
          <Icon name="Download" className="w-8 h-8 text-primary" />
        </div>
        <h3 className="text-2xl font-bold text-text-primary mb-2">
          Free Automation Resources
        </h3>
        <p className="text-text-secondary max-w-lg mx-auto">
          Download templates, guides, and blueprints to accelerate your automation
          journey.
        </p>
      </div>

      {/* Simple vertical list to avoid any overlap in narrow sidebar */}
      <div className="grid grid-cols-1 gap-4 sm:gap-5">
        {resources.map((resource) => (
          <div
            key={resource.id}
            className="bg-card border border-border rounded-lg p-5 sm:p-6 hover:shadow-lg transition-all duration-200 group flex flex-col"
          >
            {/* Icon + Title */}
            <div className="flex items-start space-x-4 mb-4">
              <div
                className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${typeColors[resource.type]}20` }}
              >
                <Icon
                  name={resource.icon as any}
                  className="w-6 h-6"
                  color={typeColors[resource.type]}
                />
              </div>

              <div className="flex-1 min-w-0">
                <h4 className="text-base font-semibold text-text-primary mb-1 group-hover:text-primary transition-colors">
                  {resource.title}
                </h4>
                <p className="text-sm text-text-secondary">
                  {resource.description}
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between pt-4 border-t border-border">
              <div className="flex items-center space-x-2 text-xs text-text-secondary">
                <Icon name="Download" className="w-3.5 h-3.5" />
                <span>{resource.downloads.toLocaleString()} downloads</span>
              </div>

              <Button
                variant="ghost"
                size="sm"
                iconName="ArrowRight"
                iconPosition="right"
                className="whitespace-nowrap"
              >
                Download
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResourcesSection;
